import * as React from 'react';
import { AppBanner } from '../AppBanner';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { useDispatch, useSelector } from 'react-redux';
import { useSelectedLocationData, RecordDataState } from '../../hooks/data-hooks';
import { Selectors } from '../../selectors';
import { Actions } from '../../actions';

export const AutoRedirectBanner: React.FC = () => {
    const { t } = useLanguageLocale();
    const dispatch = useDispatch();
    const selectedLocationData = useSelectedLocationData();

    const isShown = useSelector(Selectors.Dashboard.isAutoRedirectBannerShown);

    // const onAddLocationClicked = React.useCallback(() => {
    //     /**/
    // }, []);
    const onDismissClicked = React.useCallback(() => dispatch(Actions.Dashboard.autoRedirectBannerDismissed()), [
        dispatch,
    ]);

    if (!isShown) {
        return null;
    }

    if (selectedLocationData.state !== RecordDataState.Found) {
        return null;
    }

    return (
        <AppBanner
            icon="SubdirectoryArrowRight"
            message={t('DASHBOARD.AUTO_REDIRECT_BANNER.MESSAGE', {
                replace: { location: selectedLocationData.value.name },
            })}
            buttons={[
                // {
                //     label: t('DASHBOARD.AUTO_REDIRECT_BANNER.ADD_LOCATION_BUTTON'),
                //     disabled: true,
                //     onClick: onAddLocationClicked,
                // },
                {
                    label: t('DASHBOARD.AUTO_REDIRECT_BANNER.DISMISS'),
                    disabled: false,
                    onClick: onDismissClicked,
                },
            ]}
        />
    );
};
